import { render, staticRenderFns } from "./PartPopup.vue?vue&type=template&id=52646e51&scoped=true&"
import script from "./PartPopup.vue?vue&type=script&lang=js&"
export * from "./PartPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52646e51",
  null
  
)

export default component.exports